export default {"src":"/_next/static/media/bareMetalEmulators.55796cfc.svg","height":1000,"width":1000,"blurWidth":0,"blurHeight":0};